<template>
    <app-content-admin>
        <template slot="header">Add AdZone </template>
        <template slot="button">
            <v-btn
                style="margin-left: auto"
                large
                color="secondary"
                to="/adzone"
            >
                Back
            </v-btn>
        </template>

        <v-layout row wrap>
            <v-flex xs12 lg6 mx-auto>
                <v-card>
                    <v-card-text>
                        <v-container fluid grid-list-xs>
                            <v-layout wrap>
                                <v-flex xs12>
                                    <v-text-field
                                        :label="$t('Name')"
                                        v-model="form.zone_name"
                                        :rules="[rules.required('Name')]"
                                        :data-label="$t('Name')"
                                        outlined
                                    >
                                    </v-text-field>
                                </v-flex>
                                <v-flex xs12>
                                    <v-text-field
                                        :label="$t('Description')"
                                        v-model="form.zone_description"
                                        :rules="[rules.required('Description')]"
                                        :data-label="$t('Description')"
                                        outlined
                                    >
                                    </v-text-field>
                                </v-flex>

                                <v-flex xs12>
                                    <v-text-field
                                        :label="$t('Rotate Time(Seconds)')"
                                        v-model="form.zone_rotate_time"
                                        :data-label="$t('Rotate Time(Seconds)')"
                                        outlined
                                        type="number"
                                        min="0"
                                        @input="handleZoneRotateTimeInput"
                                        :rules="[
                                            rules.required(
                                                'Rotate Time(Seconds)'
                                            ),
                                        ]"
                                    >
                                    </v-text-field>
                                </v-flex>

                                <v-flex xs12>
                                    <v-switch
                                        :label="$t('Active')"
                                        v-model="form.zone_active"
                                        :data-label="$t('Active')"
                                        outlined
                                    ></v-switch>
                                </v-flex>
                            </v-layout>
                        </v-container>
                    </v-card-text>

                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn
                            color="primary"
                            @click="createAdzone"
                            class="form-submit"
                        >
                            Submit
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-flex>
        </v-layout>
    </app-content-admin>
</template>

<script>
import vForm from "@/mixins/vForm";
import ActiveLabel from "../../components/status/ActiveLabel.vue";
import store from "@/store";

export default {
    mixins: [vForm],

    data() {
        return {
            project_list: [],
            form: {
                zone_name: null,
                zone_description: null,
                zone_active: 0,
                zone_rotate_time: 0,
            },
        };
    },

    components: { ActiveLabel },

    created() {},

    methods: {
        //Create new zone data
        async createAdzone() {
            let loader = this.$loading.show();
            try {
                let res = await axios.post(
                    `/api/auth/create_ad_zone`,
                    this.form
                );
                if (res.status == 200) {
                    console.log("Create Adz Success", res.adzone);
                    this.$toastr.s("AdZone created successfully");
                    this.$router.push("/adzone");
                }
            } catch (err) {
                if (err.response.status === 400) {
                    // Validation errors returned by the server
                  //  this.$toastr.e("Please input all required data");
                } else {
                   // this.$toastr.e( "An error occurred while creating the AdZone.");
                    console.log("Error create adZone", err);
                }
            } finally {
                loader.hide();
            }
        },

        //Prevent zero or neg typing for rotate time
        handleZoneRotateTimeInput() {
            // Ensure that the value is not negative
            if (this.form.zone_rotate_time < 0) {
                this.form.zone_rotate_time = 0;
            }

            // Remove leading zeros
            if (
                this.form.zone_rotate_time.length > 1 &&
                this.form.zone_rotate_time[0] === "0"
            ) {
                this.form.zone_rotate_time =
                    this.form.zone_rotate_time.slice(1);
            }
        },
    },
};
</script>
